import type { ReactNode } from "react";
import CloudLinkBanner from "../../../components/CloudLinkBanner";

/**
 * Коренът на модул „Маркиране": цялата височина, pos-* платно и лентата за
 * връзката с облака най-отгоре (docs/edge.md) — над горната лента при масите
 * и над продуктовия изглед на десктоп, който няма горна лента. Обвива и
 * скелетона, докато менюто се зарежда, за да не мига лентата при прехода.
 * Лентата мълчи, докато всичко е наред, и говори при бавен/мълчащ облак, при
 * терминал без интернет, при наш деплой и в локален режим.
 */
export function OrderingShell({ children }: { children: ReactNode }) {
  return (
    <div className="h-screen flex flex-col overflow-hidden bg-pos-canvas font-pos-sans text-pos-ink">
      <CloudLinkBanner variant="pos" />
      {children}
    </div>
  );
}
